@if (link) {
<div class="notification-container" (click)="handleLink()" [style.cursor]="link && 'pointer'">
  <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
</div>
} @else {
<div class="notification-container">
  <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
</div>
} @if (notification.acknowledge) {
<button mat-icon-button class="icon-button new-releases-icon-button">
  <span><mat-icon (click)="handleLink()" svgIcon="new_releases" class="icon new-releases-icon"></mat-icon></span>
</button>
} @if (!isRead && !manuallyRead) {
<button mat-icon-button class="icon-button mark-read-button" (click)="markAsRead($event)">
  <mat-icon svgIcon="check_circle_outline" class="icon"></mat-icon>
</button>
}

<ng-template #notificationContent>
  <div class="h4">{{ notification.subject }}</div>
  <div class="message h5">{{ notification.message }}</div>
  <div class="time h5">{{ notification.occurrenceTime | dayjsDateTime }}</div>
</ng-template>
